export enum ReadingStatus {
  Pending = 1,
  Completed,
}

export const readingStatuses = (): Record<ReadingStatus, string> => ({
  [ReadingStatus.Pending]: 'Pending',
  [ReadingStatus.Completed]: 'Completed',
})
